import React, { useState } from 'react';
import HomeTab from './MobileHome';
import MedsTab from './MobileMeds';
import ReportsTab from './MobileReports';
import AITab from './MobileAI';
import AccessTab from './MobileAccess';
import EmergencyTab from './MobileEmergency';
import UserProfile from './MobileUserprofile';
import Settings from './MobileSettings';
import HelpCenter from './MobileHelpCenter';
import MobileLogout from './MobileLogout';
import MobileNotifications from './MobileNotifications';
import MobileConditions from './MobileConditions';
import MobileVitals from './MobileVitals';

const MHJLogo = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="200 250 690 580" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="mhjG" gradientUnits="userSpaceOnUse" x1="216" y1="0" x2="883" y2="0">
        <stop offset="0%" stopColor="#0a3fe0"/>
        <stop offset="30%" stopColor="#3a54da"/>
        <stop offset="60%" stopColor="#a42ea3"/>
        <stop offset="100%" stopColor="#e2368c"/>
      </linearGradient>
    </defs>
    <path fill="url(#mhjG)" fillRule="evenodd"
      d="M 496.00,344.00 C 495.10,340.80 481.87,333.69 479.00,332.00 C 476.13,330.31 454.79,319.09 450.00,317.00 C 445.21,314.91 421.08,306.25 417.00,305.00 C 412.92,303.75 394.81,299.69 391.00,299.00 C 387.19,298.31 370.86,296.21 367.00,296.00 C 363.14,295.79 336.07,295.92 335.00,296.00 C 333.93,296.08 329.80,298.36 329.00,299.00 C 328.20,299.64 325.48,303.11 325.00,304.00 C 324.52,304.89 323.01,308.99 323.00,310.00 C 322.99,311.01 323.00,478.77 323.00,479.00 C 323.00,479.23 323.77,479.99 324.00,480.00 C 324.23,480.01 349.77,480.01 350.00,480.00 C 350.23,479.99 351.00,479.23 351.00,479.00 C 351.00,478.77 350.99,328.68 351.00,328.00 C 351.01,327.32 353.33,325.11 354.00,325.00 C 354.67,324.89 366.61,324.80 369.00,325.00 C 371.39,325.20 386.69,327.26 390.00,328.00 C 393.31,328.74 417.84,335.17 423.00,337.00 C 428.16,338.83 451.85,349.45 455.00,351.00 C 458.15,352.55 471.68,360.52 474.00,362.00 C 476.32,363.48 487.69,371.82 488.00,372.00 C 488.31,372.18 489.90,371.34 490.00,371.00 C 490.10,370.66 496.90,347.20 496.00,344.00 Z M 263.00,361.00 C 262.36,403.88 261.64,452.12 261.00,495.00 C 248.20,496.60 233.80,498.40 221.00,500.00 C 221.00,507.36 221.00,515.64 221.00,523.00 C 282.12,523.96 402.75,528.01 412.00,526.00 C 421.25,523.99 432.40,491.32 442.00,475.00 C 454.16,504.12 467.84,536.88 480.00,566.00 C 486.08,562.48 497.98,558.36 499.00,555.00 C 500.02,551.64 524.84,434.64 537.00,378.00 C 550.12,454.48 564.88,540.52 578.00,617.00 C 584.40,614.12 596.77,611.29 598.00,608.00 C 599.23,604.71 621.12,516.20 632.00,473.00 C 638.40,480.36 647.12,495.96 652.00,496.00 C 656.88,496.04 729.31,473.85 741.00,474.00 C 752.69,474.15 806.38,486.88 810.00,498.00 C 813.62,509.12 808.64,621.76 808.00,680.00 C 774.08,679.68 718.73,676.21 702.00,679.00 C 685.27,681.79 623.12,704.84 586.00,717.00 C 609.36,700.04 645.77,669.77 659.00,664.00 C 672.23,658.23 762.43,650.04 774.00,635.00 C 785.57,619.96 776.84,516.38 776.00,512.00 C 775.16,507.62 757.64,507.24 749.00,505.00 C 748.36,539.24 758.17,599.02 747.00,612.00 C 735.83,624.98 640.37,640.49 626.00,648.00 C 611.63,655.51 574.32,693.56 550.00,715.00 C 523.44,692.60 482.44,652.96 467.00,645.00 C 451.56,637.04 362.45,621.36 354.00,614.00 C 345.55,606.64 351.96,566.40 351.00,544.00 C 342.04,544.00 331.96,544.00 323.00,544.00 C 325.24,574.72 319.20,629.02 330.00,640.00 C 340.80,650.98 429.15,659.39 442.00,665.00 C 454.85,670.61 488.92,701.72 511.00,719.00 C 476.44,706.52 420.66,683.05 403.00,680.00 C 385.34,676.95 326.84,680.68 291.00,681.00 C 290.36,637.16 289.64,587.84 289.00,544.00 C 280.36,543.68 270.64,543.32 262.00,543.00 C 263.60,596.12 265.40,655.88 267.00,709.00 C 315.00,709.96 393.59,706.69 417.00,712.00 C 440.41,717.31 537.67,774.76 558.00,775.00 C 578.33,775.24 650.29,719.96 670.00,715.00 C 689.71,710.04 782.88,708.20 836.00,705.00 C 836.96,638.76 838.04,564.24 839.00,498.00 C 849.88,497.36 870.00,497.36 873.00,496.00 C 876.00,494.64 879.80,483.76 883.00,478.00 C 844.60,470.64 801.40,462.36 763.00,455.00 C 788.60,424.60 839.37,366.40 843.00,360.00 C 846.63,353.60 845.19,320.33 843.00,314.00 C 840.81,307.67 821.85,285.26 816.00,282.00 C 810.15,278.74 779.30,274.03 773.00,275.00 C 766.70,275.97 744.37,294.08 738.00,294.00 C 731.63,293.92 697.15,273.65 689.00,274.00 C 680.85,274.35 647.75,294.44 644.00,298.00 C 640.25,301.56 632.55,322.86 632.00,328.00 C 631.45,333.14 633.97,359.04 637.00,364.00 C 640.03,368.96 680.52,416.36 701.00,441.00 C 708.36,435.56 716.64,429.44 724.00,424.00 C 704.16,400.64 664.82,357.35 662.00,351.00 C 659.18,344.65 669.95,312.59 673.00,309.00 C 676.05,305.41 697.58,302.38 702.00,304.00 C 706.42,305.62 728.52,324.40 741.00,334.00 C 750.60,325.04 767.63,307.87 771.00,306.00 C 774.37,304.13 791.31,302.88 795.00,304.00 C 798.69,305.12 812.11,315.62 814.00,319.00 C 815.89,322.38 819.54,341.08 818.00,345.00 C 816.46,348.92 791.53,386.35 785.00,393.00 C 778.47,399.65 708.37,458.67 703.00,462.00 C 697.63,465.33 669.54,471.03 664.00,468.00 C 658.46,464.97 641.31,429.36 639.00,427.00 C 636.69,424.64 625.40,423.60 619.00,422.00 C 609.08,454.96 597.92,492.04 588.00,525.00 C 574.88,444.04 560.12,352.96 547.00,272.00 C 539.64,275.20 525.13,278.15 524.00,282.00 C 522.87,285.85 494.76,427.52 481.00,496.00 C 473.32,474.56 458.64,431.86 457.00,429.00 C 455.36,426.14 444.08,423.56 438.00,421.00 C 425.84,445.32 412.08,490.76 400.00,497.00 C 387.92,503.24 325.88,497.00 291.00,497.00 C 290.36,461.48 288.64,388.77 289.00,386.00 C 289.36,383.23 304.62,384.43 306.00,382.00 C 307.38,379.57 306.00,364.32 306.00,356.00 C 292.24,357.60 276.76,359.40 263.00,361.00 Z"
    />
  </svg>
);

const RobotAvatar = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="40" fill="url(#bot-gradient)" />
    <circle cx="40" cy="17" r="3.4" fill="white" />
    <line x1="40" y1="20.4" x2="40" y2="27" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
    <rect x="15.5" y="35" width="7" height="15" rx="3.5" fill="white" />
    <rect x="57.5" y="35" width="7" height="15" rx="3.5" fill="white" />
    <rect x="24" y="27" width="32" height="27" rx="9" fill="white" />
    <circle cx="33.5" cy="39.5" r="3.6" fill="url(#bot-gradient)" />
    <circle cx="46.5" cy="39.5" r="3.6" fill="url(#bot-gradient)" />
    <path d="M32 47 C 35.5 51, 44.5 51, 48 47" stroke="url(#bot-gradient)" strokeWidth="2.6" strokeLinecap="round" fill="none" />
    <path d="M28 58 C 28 54.5, 52 54.5, 52 58 L 48.5 66 C 48 67.5 46.8 68 45.5 68 H 34.5 C 33.2 68 32 67.5 31.5 66 Z" fill="white" />
    <defs>
      <linearGradient id="bot-gradient" x1="4" y1="4" x2="76" y2="76" gradientUnits="userSpaceOnUse">
        <stop stopColor="#c026a3" />
        <stop offset="1" stopColor="#7c3aed" />
      </linearGradient>
    </defs>
  </svg>
);

export default function MobilePatientDashboard({ user, onLogout }) {
  const [activeTab, setActiveTab] = useState('home');
  const [screen, setScreen] = useState('dashboard');
  const [showLogout, setShowLogout] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [aiPanelOpen, setAiPanelOpen] = useState(false);
  const [aiInput, setAiInput] = useState('');
  const [aiMessages, setAiMessages] = useState([
    { role: 'assistant', text: `Hello ${user?.name?.split(' ')[0] || 'there'}! I can help you understand your reports or medications.` }
  ]);
  const [aiLoading, setAiLoading] = useState(false);
  const [showAddHealth, setShowAddHealth] = useState(false);

  const sendAiMessage = async () => {
    if (!aiInput.trim()) return;
    const msg = aiInput.trim();
    setAiMessages(prev => [...prev, { role: 'user', text: msg }]);
    setAiInput('');
    setAiLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/AI/chat`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ patientId: user.id, message: msg })
      });
      const data = await res.json();
      setAiMessages(prev => [...prev, { role: 'assistant', text: data.response || 'Sorry, could not process that.' }]);
    } catch {
      setAiMessages(prev => [...prev, { role: 'assistant', text: 'Cannot connect to AI service.' }]);
    }
    setAiLoading(false);
  };

  if (screen === 'profile') return <UserProfile user={user} onBack={() => setScreen('dashboard')} />;
  if (screen === 'settings') return <Settings user={user} onBack={() => setScreen('dashboard')} />;
  if (screen === 'help') return <HelpCenter onBack={() => setScreen('dashboard')} />;
  if (showNotifications) return <MobileNotifications onBack={() => setShowNotifications(false)} />;

  // ✅ AI tab gets its own full-screen fixed layout
  if (activeTab === 'ai') {
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', fontFamily: 'Inter, sans-serif', background: '#F4F7FC' }}>
        {/* Header */}
        <header style={{ height: '64px', background: '#fff', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', flexShrink: 0, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div className="flex items-center gap-2">
            <MHJLogo size={32} />
            <span className="font-extrabold text-xl text-[#0f172a] tracking-tight">My Health</span>
            <span className="font-extrabold text-xl tracking-tight" style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 55%, #5a4bdc 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Journal</span>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => setShowNotifications(true)} className="relative w-9 h-9 flex items-center justify-center text-gray-700 hover:bg-gray-100 rounded-full">
              <span className="material-symbols-outlined text-2xl">notifications</span>
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
            </button>
            <button onClick={() => setProfileOpen(!profileOpen)} className="w-9 h-9 rounded-full overflow-hidden shadow-sm">
              <div className="w-full h-full bg-[#1e293b] flex items-center justify-center text-white font-extrabold text-base">
                {user?.name?.charAt(0) || 'A'}
              </div>
            </button>
          </div>
        </header>

        {/* ✅ AI Tab — fills remaining space perfectly */}
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <AITab user={user} />
        </div>

        {/* Bottom Nav */}
        <nav style={{ height: '64px', background: '#fff', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-around', alignItems: 'center', flexShrink: 0, padding: '0 8px', boxShadow: '0 -1px 4px rgba(0,0,0,0.06)' }}>
          {[
            { id: 'home', icon: 'home', label: 'Home' },
            { id: 'health', icon: 'favorite', label: 'Health' },
            { id: 'reports', icon: 'description', label: 'Reports' },
            { id: 'ai', icon: 'auto_awesome', label: 'AI' },
            { id: 'access', icon: 'group', label: 'Access' },
          ].map(tab => {
            const isActive = tab.id === 'ai';
            return (
              <button key={tab.id}
                onClick={() => { if (tab.id === 'health') setActiveTab('meds'); else setActiveTab(tab.id); }}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '4px 0', color: isActive ? '#0B3C95' : '#9ca3af', position: 'relative', background: 'none', border: 'none', cursor: 'pointer' }}>
                <span className="material-symbols-outlined" style={{ fontSize: '24px', fontVariationSettings: isActive ? '"FILL" 1' : '"FILL" 0' }}>{tab.icon}</span>
                <span style={{ fontSize: '10px', fontWeight: 700, marginTop: '2px' }}>{tab.label}</span>
                {isActive && <div style={{ position: 'absolute', bottom: 0, width: '32px', height: '3px', background: '#0B3C95', borderRadius: '3px 3px 0 0' }} />}
              </button>
            );
          })}
        </nav>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F4F7FC]" style={{ fontFamily: 'Inter, sans-serif', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>

      {showLogout && <MobileLogout onLogout={onLogout} onCancel={() => setShowLogout(false)} />}

      {/* TOP HEADER */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 px-4 h-16 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-2">
          <MHJLogo size={32} />
          <span className="font-extrabold text-xl text-[#0f172a] tracking-tight">My Health</span>
          <span className="font-extrabold text-xl tracking-tight" style={{ background: 'linear-gradient(90deg, #e62e8a 0%, #8b3fd6 55%, #5a4bdc 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Journal</span>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setShowNotifications(true)} className="relative w-9 h-9 flex items-center justify-center text-gray-700 hover:bg-gray-100 rounded-full">
            <span className="material-symbols-outlined text-2xl">notifications</span>
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
          </button>
          <button onClick={() => setProfileOpen(!profileOpen)} className="w-9 h-9 rounded-full overflow-hidden shadow-sm">
            {localStorage.getItem(`patient_photo_${user?.id}`) ? (
              <img src={localStorage.getItem(`patient_photo_${user?.id}`)} alt="Profile" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full bg-[#1e293b] flex items-center justify-center text-white font-extrabold text-base">
                {user?.name?.charAt(0) || 'A'}
              </div>
            )}
          </button>
        </div>
      </header>

      {/* PROFILE POPUP */}
      {profileOpen && (
        <>
          <div className="fixed inset-0 z-[90]" onClick={() => setProfileOpen(false)}></div>
          <div className="fixed top-16 right-4 z-[100] w-72 bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">
            <div className="p-4 border-b border-gray-100" style={{ background: 'linear-gradient(135deg, #0B3C95, #1E65FF)' }}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white/30 shrink-0">
                  {localStorage.getItem(`patient_photo_${user?.id}`) ? (
                    <img src={localStorage.getItem(`patient_photo_${user?.id}`)} alt="Profile" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full bg-white/20 flex items-center justify-center text-white font-black text-xl">
                      {user?.name?.charAt(0) || 'A'}
                    </div>
                  )}
                </div>
                <div>
                  <p className="font-bold text-white text-base">{user?.name}</p>
                  <p className="text-white/70 text-xs font-mono break-all">{user?.patientUid}</p>
                </div>
              </div>
              <div className="bg-white/10 rounded-xl px-3 py-2 flex items-center gap-2">
                <span className="material-symbols-outlined text-white/70 text-sm" style={{ fontVariationSettings: '"FILL" 1' }}>qr_code</span>
                <p className="text-white/80 text-xs">Tap QR on home screen to expand</p>
              </div>
            </div>
            <div className="py-1">
              {[
                { icon: 'person', label: 'User Profile', action: () => { setScreen('profile'); setProfileOpen(false); } },
                { icon: 'settings', label: 'Settings', action: () => { setScreen('settings'); setProfileOpen(false); } },
                { icon: 'help', label: 'Help Center', action: () => { setScreen('help'); setProfileOpen(false); } },
                { icon: 'e911_emergency', label: 'Emergency / SOS', action: () => { setActiveTab('emergency'); setProfileOpen(false); } },
              ].map(item => (
                <button key={item.label} onClick={item.action}
                  className="w-full flex items-center justify-between px-5 py-3 hover:bg-gray-50 text-sm font-semibold text-gray-700">
                  <div className="flex items-center gap-3">
                    <span className="material-symbols-outlined text-gray-400 text-xl">{item.icon}</span>
                    {item.label}
                  </div>
                  <span className="material-symbols-outlined text-gray-300 text-lg">chevron_right</span>
                </button>
              ))}
              <div className="border-t border-gray-100 my-1"></div>
              <button onClick={() => { setProfileOpen(false); setShowLogout(true); }}
                className="w-full flex items-center justify-between px-5 py-3 hover:bg-red-50 text-sm font-semibold text-red-600">
                <div className="flex items-center gap-3">
                  <span className="material-symbols-outlined text-xl">logout</span>
                  Logout
                </div>
                <span className="material-symbols-outlined text-red-300 text-lg">chevron_right</span>
              </button>
            </div>
            <div className="p-3 border-t border-gray-100">
              <button onClick={() => setProfileOpen(false)} className="w-full py-2 bg-gray-100 text-gray-600 text-sm font-semibold rounded-full">Close</button>
            </div>
          </div>
        </>
      )}

      {/* MAIN CONTENT */}
      <main style={{ paddingTop: '64px', paddingBottom: '80px' }}>
        {activeTab === 'home' && <HomeTab user={user} setActiveTab={setActiveTab} />}
        {activeTab === 'reports' && <ReportsTab user={user} />}
        {activeTab === 'access' && <AccessTab user={user} />}
        {activeTab === 'emergency' && <EmergencyTab user={user} />}

        {['meds', 'vitals', 'conditions'].includes(activeTab) && (
          <div>
            <div className="sticky top-16 z-30 bg-white border-b border-gray-100 px-4 py-2.5 flex items-center justify-between shadow-sm">
              <div className="flex gap-2">
                {[
                  { id: 'meds', icon: 'pill', label: 'Meds' },
                  { id: 'vitals', icon: 'monitor_heart', label: 'Vitals' },
                  { id: 'conditions', icon: 'health_and_safety', label: 'Conditions' },
                ].map(t => (
                  <button key={t.id} onClick={() => setActiveTab(t.id)}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold transition-all ${activeTab === t.id ? 'bg-[#0B3C95] text-white shadow-sm' : 'bg-gray-100 text-gray-500'}`}>
                    <span className="material-symbols-outlined text-sm" style={{ fontVariationSettings: activeTab === t.id ? '"FILL" 1' : '"FILL" 0' }}>{t.icon}</span>
                    {t.label}
                  </button>
                ))}
              </div>
              {(activeTab === 'vitals' || activeTab === 'conditions') && (
                <button onClick={() => setShowAddHealth(true)}
                  className="w-8 h-8 bg-[#0B3C95] text-white rounded-full flex items-center justify-center active:scale-95 shrink-0 shadow-sm">
                  <span className="material-symbols-outlined text-sm">add</span>
                </button>
              )}
            </div>
            {activeTab === 'meds' && <MedsTab user={user} showAdd={showAddHealth} onAddClose={() => setShowAddHealth(false)} />}
            {activeTab === 'vitals' && <MobileVitals user={user} showAdd={showAddHealth} onAddClose={() => setShowAddHealth(false)} />}
            {activeTab === 'conditions' && <MobileConditions user={user} showAdd={showAddHealth} onAddClose={() => setShowAddHealth(false)} />}
          </div>
        )}
      </main>

      {/* FLOATING AI BUTTON */}
      <div className="fixed bottom-20 right-4 z-50 flex flex-col items-end gap-3">
        {aiPanelOpen && (
          <div className="w-80 h-96 bg-white rounded-3xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden">
            <div className="p-4 flex justify-between items-center" style={{ background: 'linear-gradient(135deg, #c026a3, #7c3aed)' }}>
              <div className="flex items-center gap-2">
                <RobotAvatar size={28} />
                <div>
                  <p className="text-white font-bold text-sm">AI Health Assistant</p>
                  <p className="text-white/70 text-xs">Powered by MyHealth Journal</p>
                </div>
              </div>
              <button onClick={() => setAiPanelOpen(false)} className="text-white hover:bg-white/10 rounded-full p-1">
                <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>close</span>
              </button>
            </div>
            <div className="flex-1 p-3 overflow-y-auto bg-gray-50 flex flex-col gap-2">
              {aiMessages.map((msg, i) => (
                <div key={i} className={`max-w-[85%] p-3 rounded-2xl text-xs ${msg.role === 'assistant' ? 'bg-white text-[#0D1B2A] rounded-tl-none shadow-sm' : 'text-white ml-auto rounded-tr-none'}`}
                  style={msg.role === 'user' ? { background: 'linear-gradient(135deg, #c026a3, #7c3aed)' } : undefined}>
                  {msg.text}
                </div>
              ))}
              {aiLoading && <div className="bg-white p-3 rounded-2xl text-xs text-gray-400 max-w-[85%] shadow-sm">Thinking...</div>}
            </div>
            <div className="p-3 bg-white border-t border-gray-100">
              <div className="flex items-center gap-2 bg-gray-100 rounded-full px-3 py-2">
                <input type="text" placeholder="Ask anything..."
                  className="flex-1 bg-transparent border-none text-xs outline-none text-[#0D1B2A] placeholder-gray-400"
                  value={aiInput} onChange={e => setAiInput(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && sendAiMessage()} />
                <button onClick={sendAiMessage} className="w-7 h-7 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #c026a3, #7c3aed)' }}>
                  <span className="material-symbols-outlined text-white" style={{ fontSize: '14px' }}>send</span>
                </button>
              </div>
            </div>
          </div>
        )}
        <button onClick={() => setAiPanelOpen(!aiPanelOpen)}
          className="w-14 h-14 rounded-full flex items-center justify-center shadow-2xl active:scale-95 transition-all"
          style={{ background: 'linear-gradient(135deg, #c026a3, #7c3aed)', boxShadow: '0 8px 25px rgba(124,58,237,0.45)' }}>
          <RobotAvatar size={36} />
        </button>
      </div>

      {/* BOTTOM NAV */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 flex justify-around items-center h-16 z-40 px-2 shadow-lg">
        {[
          { id: 'home', icon: 'home', label: 'Home' },
          { id: 'health', icon: 'favorite', label: 'Health' },
          { id: 'reports', icon: 'description', label: 'Reports' },
          { id: 'ai', icon: 'auto_awesome', label: 'AI' },
          { id: 'access', icon: 'group', label: 'Access' },
        ].map(tab => {
          const isActive = tab.id === 'health'
            ? ['meds', 'vitals', 'conditions'].includes(activeTab)
            : activeTab === tab.id;
          return (
            <button key={tab.id}
              onClick={() => { if (tab.id === 'health') setActiveTab('meds'); else setActiveTab(tab.id); }}
              className={`flex-1 flex flex-col items-center justify-center py-1 transition-all relative ${isActive ? 'text-[#0B3C95]' : 'text-gray-400'}`}>
              <span className="material-symbols-outlined text-2xl" style={{ fontVariationSettings: isActive ? '"FILL" 1' : '"FILL" 0' }}>{tab.icon}</span>
              <span className="text-[10px] font-bold mt-0.5">{tab.label}</span>
              {isActive && <div className="absolute bottom-0 w-8 h-1 bg-[#0B3C95] rounded-t-full" />}
            </button>
          );
        })}
      </nav>
    </div>
  );
}